import { loadScript } from '@/resources/utils/global/miscellaneous'

export const ZENDESK_SNIPPET_ID = 'ze-snippet'

let pendingLoader: Promise<void> | null = null

export const loadZendeskSnippet = (src: string) => {
  if (!src) {
    return Promise.reject(new Error('Zendesk snippet URL is not configured'))
  }

  if (globalThis.zE) {
    return Promise.resolve()
  }

  const existingScript = document.getElementById(ZENDESK_SNIPPET_ID)
  if (existingScript && pendingLoader) {
    return pendingLoader
  }

  if (existingScript && !pendingLoader) {
    return Promise.resolve()
  }

  pendingLoader = new Promise((resolve, reject) => {
    loadScript({
      src,
      onHead: true,
      defer: true,
      onLoad: () => {
        resolve()
        return null
      },
      onError: () => {
        pendingLoader = null
        reject(new Error('Failed to load Zendesk snippet'))
        return null
      },
    }).id = ZENDESK_SNIPPET_ID
  })

  return pendingLoader
}
